import Icon from './Icon';

const Saved = (props) => {
  // eslint-disable-next-line react/prop-types
  const { color } = props;
  return (
    <Icon
      {...props}
      title="Saved"
      viewBox="0 0 24 24"
      pathFillRule="evenodd"
      pathClipRule="evenodd"
      path="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  );
};

export default Saved;
